import * as yup from 'yup'
import { getLoyaltyCode } from 'src/deps'
export const schema = props => {
  const loyaltyCodeSchema = Object.assign(
    {},
    getLoyaltyCode({ inputName: 'loyaltyPoint' })
  )
  return yup.object(loyaltyCodeSchema)
}
